<template>
  <b-modal
    id="cadastrarConta"
    hide-footer
    centered
    size="xl"
    title="Cadastrar Conta"
  >
    <b-card>
      <b-alert :variant="getErrors.color" v-if="getErrors.hasMessage" show>
        <div
          class="alert-body"
          v-for="(error, index) in getErrors.messageArray"
          :key="index"
        >
          {{ error[0] }}
        </div>

        <div class="alert-body">{{ getErrors.message }}</div>
      </b-alert>

      <div class="d-flex">
        <feather-icon icon="BoxIcon" size="19" />
        <h4 class="mb-2 ml-50">Dados da Conta</h4>
      </div>

      <validation-observer ref="contaCadastroValidation">
        <b-form class="mt-1">
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="Nome *" label-for="nome">
                <validation-provider
                  #default="{ errors }"
                  name="Nome"
                  rules="required|max:60"
                >
                  <b-form-input
                    id="nome"
                    v-model="form.nome"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="3" lg="3">
              <b-form-group label="Agência" label-for="num_agencia">
                <validation-provider #default="{ errors }" name="Agencia">
                  <cleave
                    id="num_agencia"
                    v-model="form.num_agencia"
                    class="form-control"
                    :raw="false"
                    :options="options.num_agencia"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="3" lg="3">
              <b-form-group label="Número da Conta" label-for="num_conta">
                <validation-provider
                  #default="{ errors }"
                  name="Número da Conta"
                >
                  <cleave
                    id="num_conta"
                    v-model="form.num_conta"
                    class="form-control"
                    :raw="false"
                    :options="options.num_conta"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group label="Saldo Inicial" label-for="saldo_inicial">
                <validation-provider #default="{ errors }" name="saldo_inicial">
                  <money
                    v-model="form.saldo_inicial"
                    v-bind="money"
                    :state="errors.length > 0 ? false : null"
                    class="form-control"
                  />
                  <!-- @keyup.native="valorDocumentoChange()" -->
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col>
              <b-button
                variant="primary"
                class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                :disabled="submit"
                @click="cadastrar"
              >
                <b-spinner small v-if="spinner" />
                <span v-if="spinner">Aguarde...</span>
                <span v-else>Cadastrar</span>
              </b-button>

              <b-button
                variant="outline-secondary"
                @click="$bvModal.hide('cadastrarConta')"
              >
                Fechar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import {
  BAlert,
  BButton,
  BCard,
  BCol,
  BForm,
  BFormCheckboxGroup,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BModal,
  BRow,
  BSpinner,
} from "bootstrap-vue";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@validations";
import Cleave from "vue-cleave-component";

// eslint-disable-next-line import/no-extraneous-dependencies
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BInputGroupAppend,
    BInputGroup,
    BSpinner,
    BAlert,
    BModal,
    BFormSelect,
    Cleave,
  },

  data() {
    return {
      required,
      getErrors: {
        hasMessage: false,
        color: "danger",
        message: "",
        messageArray: "",
      },
      form: {
        id: "",
        nome: "",
        num_conta: null,
        num_agencia: null,
        saldo_inicial: 0,
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      options: {
        num_agencia: {
          delimiters: ["-"],
          blocks: [4, 1],
          numericOnly: true,
          delimiterLazyShow: true,
          rawValueTrimPrefix: true,
        },
        num_conta: {
          delimiters: ["-"],
          blocks: [8, 1],
          numericOnly: true,
          delimiterLazyShow: true,
          rawValueTrimPrefix: true,
        },
      },
      spinner: false,
      submit: false,
      errors: false,
    }
  },

  methods: {
    cadastrar() {
      this.$refs.contaCadastroValidation.validate().then((success) => {
        if (success) {
          this.spinner = true;
          this.submit = true;
          this.errors = false;

          this.$http
            .post("adm/contas", this.form)
            .then((res) => {
              this.$store.commit("contas/ADICIONAR_CONTA", res.data);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Conta Cadastrada com Sucesso!",
                  icon: "InfoIcon",
                  variant: "success",
                },
              });
              this.getErrors = false;
              this.$refs.contaCadastroValidation.reset();
              this.resetarCampos();
            })
            .catch((error) => {
              let res = this.$responseMessages.getMessage(error, null);
              this.getErrors = res;
            })
            .finally(() => {
              this.spinner = false;
              this.submit = false;
            });
        }
      });
    },

    resetarCampos() {
      this.form = {
        id: "",
        nome: "",
        num_conta: null,
        num_agencia: null,
        saldo_inicial: 0,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
